export default __webpack_public_path__ + "static/media/TurboOrange.a95e6973.svg";